/**
 * Um título com setinha que abre e fecha o que vem embaixo — como a árvore das
 * configurações do VS Code.
 *
 * Existe para as barras laterais do diagrama, que juntavam tudo numa coluna só
 * e ficavam longas demais para achar qualquer coisa.
 *
 * **O conteúdo só monta aberto.** Fechada, a seção não renderiza os filhos — e
 * com eles não vão as consultas que eles fazem. É o que deixa a barra leve com
 * dez seções: só busca o que alguém abriu.
 *
 * **Lembra o que ficou aberto**, por `chave`, no navegador. Quem sempre abre
 * Modelos não precisa abrir de novo a cada diagrama.
 */

import { useState, type ReactNode } from "react"

function lida(chave: string | undefined, padrao: boolean): boolean {
  if (!chave) return padrao
  try {
    const v = localStorage.getItem(`secao:${chave}`)
    return v == null ? padrao : v === "1"
  } catch { return padrao }
}

export function Secao({ titulo, resumo, chave, aberta = false, perigo, children }: {
  titulo: ReactNode
  /** O que aparece à direita do título — uma contagem, um estado. */
  resumo?: ReactNode
  /** Para lembrar aberta/fechada entre um diagrama e outro. */
  chave?: string
  /** Como começa quando nunca foi aberta nem fechada. */
  aberta?: boolean
  /** Título em vermelho: a seção de excluir. */
  perigo?: boolean
  children: ReactNode
}) {
  const [aberto, setAberto] = useState(() => lida(chave, aberta))

  function alternar() {
    const novo = !aberto
    setAberto(novo)
    if (chave) {
      try { localStorage.setItem(`secao:${chave}`, novo ? "1" : "0") } catch { /* sem armazenamento */ }
    }
  }

  return (
    <section style={{ borderBottom: "1px solid var(--line)" }}>
      <button
        type="button"
        onClick={alternar}
        aria-expanded={aberto}
        style={{
          display: "flex", alignItems: "center", gap: 6, width: "100%",
          padding: "8px 2px", textAlign: "left", cursor: "pointer",
          fontSize: 12, fontWeight: 600,
          color: perigo ? "var(--erro)" : "var(--txt)",
        }}
      >
        <svg width="10" height="10" viewBox="0 0 24 24" aria-hidden="true"
             style={{
               flex: "0 0 auto", fill: "none", stroke: "currentColor", strokeWidth: 3,
               strokeLinecap: "round", strokeLinejoin: "round", opacity: 0.7,
               transform: aberto ? "rotate(90deg)" : "none", transition: "transform .12s",
             }}>
          <path d="M9 5l7 7-7 7" />
        </svg>
        <span style={{ flex: 1, minWidth: 0 }}>{titulo}</span>
        {resumo != null && (
          <span style={{ fontSize: 10.5, fontWeight: 500, color: "var(--txt3)" }}>{resumo}</span>
        )}
      </button>
      {aberto && (
        <div style={{ display: "flex", flexDirection: "column", gap: 8, padding: "2px 2px 12px 18px" }}>
          {children}
        </div>
      )}
    </section>
  )
}
